import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    viewBoxSize: 48
}

const KeyListIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M46,17.43H28V13H46Zm0,4.44H28V26.3H46Zm0,8.87H28v4.43H46ZM13.5,32.45h4.64a2.49,2.49,0,0,
            0-2.43-2.2H11.29a2.51,2.51,0,0,0-2.47,2.53v8.43A4.76,4.76,0,0,0,13.5,46a4.76,4.76,0,0,0,
            4.68-4.79v-.83H13.5V37.5h4.68V35.34H13.5ZM25,13.79a11.88,11.88,0,0,1-4.44,9.3v.29a3,3,0,
            0,1-2.92,3H9.36a3,3,0,0,1-2.92-3v-.29A11.88,11.88,0,0,1,2,13.79,11.65,11.65,0,0,1,13.5,2,
            11.65,11.65,0,0,1,25,13.79ZM17.21,9.22a3.71,3.71,0,1,0-3.71,3.7A3.68,3.68,0,0,0,17.21,9.22Z`}
        />
    </SvgIcon>
)

KeyListIcon.defaultProps = defaultProps

export { KeyListIcon }
